export default __webpack_public_path__ + "images/online-payment/master-card-secure-code.svg?c6960e2e49d68f1784d941b06a4bcf0ff3a00c57298c47d31b332eb06abb50c3";